import './App.css';
import { useState, useEffect, useContext, use } from 'react';
import { ContextProvider, ContextStorage } from './Utils/Storage/ContextStorage';
import { kyra, walmart, WebCollage, AndroidCollage, UnityCollage, splat } from './Utils/Images/Imager';
import { TechnicalSkills, TechnicalSkillsHeader, Freelance, Web, Android, Unity, SplatInfo, ProjectsDescription } from './Utils/Storage/TextBase';
import { CheckPlatform } from './Utils/Components/CheckPlatform';
import { Splat } from './Utils/Components/Splat';
import { ImageConverter } from './Utils/Projects/ImageConverter';
import { ProjectDisplay } from './Utils/Components/ProjectDisplay';

function App() {

  const [noScroll, setNoScroll] = useState(false);

  useEffect(() => {
    if (noScroll) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [noScroll]);

  return (
    <div className={`App ${noScroll ? 'no-scroll' : ''}`}>
      <ContextProvider>
        <Main scroll={setNoScroll}/>
      </ContextProvider>
    </div>
  );
}

function Main({ scroll }) {
  const { playSplat, setPlaySplat, projectDisplay, } = useContext(ContextStorage);
  const { scroll: setNoScroll } = scroll;

  return (
    <>
      {
        playSplat ? (
          <Splat />
        ) : (
          <>
            {
              projectDisplay ? (
                
                <>
                  <div style={{ position: 'fixed', top: 0,  width: '100%', height: '100%', zIndex: '2', backgroundColor: 'rgba(0, 0, 0, 0.81)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <ProjectDisplay scroll={scroll} />
                  </div>
                </>
                
              ) : null
            }
            <div className="resume-container">

              <div className="resume-left no-select centered">

                <img src={kyra} alt="Profile" className="profile-photo" />
                <h2>Kyra Posey</h2>
                <p>Email: kyrajeanposey@gmail.com</p>
                <p>Location: Oklahoma City, OK</p>

                <br />

                <div className="resume-section-header centered">
                  <h4>Technical Summary</h4>
                  <p className='section-summary'>{TechnicalSkillsHeader()}</p>
                  <p className='section-summary'>{TechnicalSkills()}</p>
                </div>


                {
                  CheckPlatform() === false ? ( null ) :
                  (
                    <div className="resume-section-header centered">
                      <h4>Would you like to play a game?</h4>
                      <p className='section-summary'>{SplatInfo()}</p>
                      <button onClick={() => setPlaySplat(true)}>Play Splat!</button>
                    </div>
                  )
                }

              </div>

              <div className="resume-right no-select">

                <div className="resume-section no-select">
                  <h3>Technical Skills & Services Summary</h3>
                  <p>Freelance Developer | Foxcore DevCo</p>
                  <p>{Freelance()}</p>
                </div>

                <div className="resume-section no-select">
                  <h3>Web Development & Cloud</h3>
                  <p>{Web()}</p>
                  <br />
                  <div className="resume-section-container">
                    <WebCollage />
                    <div className="resume-section centered">
                      <ul>
                        <li>JavaScript, TypeScript, HTML5, CSS3</li>
                        <li>ReactJS, Node.js, Express.js</li>
                        <li>Firebase - Authentication, Firestore, Hosting, Cloud Functions</li>
                        <li>RESTful API design & integration</li>
                        <li>Responsive and mobile-first design</li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>

            </div>

            <div className='resume-container'>
              <div className='resume-left no-select centered'>
                <h4>Android Mobile App Development</h4>
                <p className='section-summary'>{Android()}</p>
              </div>
              <div className='resume-right no-select'>
                <div className="resume-section-container">
                    <AndroidCollage />
                    <div className="resume-section centered">
                      <ul>
                        <li>Kotlin programming expertise</li>
                        <li>Understanding of Android SDK and development tools</li>
                        <li>UI/UX design for Android apps</li>
                        <li>Firebase integration - Realtime DB & Auth</li>
                      </ul>
                    </div>
                  </div>
              </div>
            </div>

            <div className='resume-container'>
              <div className='resume-left no-select centered'>
                <h4>Game Development - Unity 3D</h4>
                <p className='section-summary'>{Unity()}</p>
              </div>
              <div className='resume-right no-select'>
                <div className="resume-section-container">
                  <UnityCollage />
                  <div className="resume-section centered">
                    <ul>
                      <li>C# scripting for gameplay mechanics</li>
                      <li>Unity UI systems and animation</li>
                      <li>Prototyping game features and tools</li>
                      <li>Basic 3D modeling environmental and architectural assets</li>
                      <li>Texturing and shading with Substance Painter</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className='resume-container'>
              <div className='resume-left no-select centered'>
                <h4>View My Projects</h4>
                <p className='section-summary'>{ProjectsDescription()}</p>
              </div>
              <div className='resume-right no-select'>
                <div className="resume-section-project-container">
                  <ImageConverter scroll={scroll} />
                </div>
              </div>
            </div>

          </>
        )
      }
    </>
  )
}

export default App;
